export function apiErrorText(i18n, body, fallback) {
    const code = body?.code;
    if (code && /^[A-Z_]{2,64}$/.test(code)) {
        const key = `errors:api.${code}`;
        if (i18n.exists(key))
            return i18n.t(key);
    }
    const raw = body?.error || body?.message;
    if (raw && (i18n.language || 'en').split('-')[0] === 'en')
        return raw;
    return fallback;
}
//# sourceMappingURL=api-error.js.map